// extracted by mini-css-extract-plugin
module.exports = {"elevatorButton":"ElevatorButton_elevatorButton__2g1hC"};